import { useEffect, useMemo, useState } from "react";
import { createDeviceProfile, } from "./DeviceProfile";
import { resolveLayoutMode, } from "./LayoutMode";
import { createUILayout, } from "./UILayoutProfile";
export function useUILayout() {
    const [device, setDevice] = useState(() => createDeviceProfile());
    useEffect(() => {
        const update = () => {
            setDevice(createDeviceProfile());
        };
        window.addEventListener("resize", update);
        window.visualViewport?.addEventListener("resize", update);
        return () => {
            window.removeEventListener("resize", update);
            window.visualViewport?.removeEventListener("resize", update);
        };
    }, []);
    const mode = useMemo(() => resolveLayoutMode(device), [device]);
    const layout = useMemo(() => createUILayout(device, mode), [device, mode]);
    return {
        device,
        mode,
        layout,
    };
}
